/* =====================================================================
   UPVCSTORE — Homepage enhancement script (index template only).
   Adds scroll-reveal classes to existing sections. No markup is moved,
   removed or reordered; without JS the page renders exactly as before.
   ===================================================================== */
(function () {
  'use strict';

  document.documentElement.classList.add('uhe-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    // Mobile keeps the stock rendering — no reveal classes at all.
    if (window.matchMedia('(max-width: 767px)').matches) return;

    var main = document.getElementById('site-main');
    if (!main) return;

    var sections = main.querySelectorAll('.shopify-section');
    var revealTargets = [];

    sections.forEach(function (section) {
      // Skip empty app wrappers so we never hide third-party embeds.
      if (section.offsetHeight < 10) return;
      section.classList.add('uhe-reveal');
      revealTargets.push(section);

      // Stagger grids of repeated cards (not blog posts — those must never
      // risk being hidden while their content lazy-loads).
      var grid = section.querySelector(
        '.highlights-banner__content, .promo-mosaic--container'
      );
      if (grid) grid.classList.add('uhe-stagger');
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealTargets.forEach(function (el) {
        el.classList.add('uhe-in');
        var grid = el.querySelector('.uhe-stagger');
        if (grid) grid.classList.add('uhe-in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('uhe-in');
          var grid = entry.target.querySelector('.uhe-stagger');
          if (grid) grid.classList.add('uhe-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    function show(el) {
      el.classList.add('uhe-in');
      var grid = el.querySelector('.uhe-stagger');
      if (grid) grid.classList.add('uhe-in');
    }

    revealTargets.forEach(function (el) {
      // Anything already in view on load shows immediately (no flash).
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) {
        show(el);
      } else {
        observer.observe(el);
      }
    });

    // Safety net: if IntersectionObserver never fires (suspended renderer,
    // odd embed contexts), reveal in-view sections on scroll and reveal
    // everything once the user has been on the page a while.
    var fallbackScroll = function () {
      revealTargets.forEach(function (el) {
        if (el.classList.contains('uhe-in')) return;
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) show(el);
      });
    };
    window.addEventListener('scroll', fallbackScroll, { passive: true });
    setTimeout(function () {
      revealTargets.forEach(show);
      window.removeEventListener('scroll', fallbackScroll);
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
